/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Eventaistartpictureunreadable4Inputs */

const en_eventaistartpictureunreadable4 = /** @type {(inputs: Eventaistartpictureunreadable4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} could not be opened. Please add it as a JPEG or PNG.`)
};

const de_eventaistartpictureunreadable4 = /** @type {(inputs: Eventaistartpictureunreadable4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} ließ sich nicht öffnen. Bitte als JPEG oder PNG hinzufügen.`)
};

/**
* | output |
* | --- |
* | "{name} could not be opened. Please add it as a JPEG or PNG." |
*
* @param {Eventaistartpictureunreadable4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventaistartpictureunreadable4 = /** @type {((inputs: Eventaistartpictureunreadable4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventaistartpictureunreadable4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventaistartpictureunreadable4(inputs)
	return de_eventaistartpictureunreadable4(inputs)
});
export { eventaistartpictureunreadable4 as "eventAiStartPictureUnreadable" }